import { useSyncExternalStore } from 'react';

export function useMediaQuery(query: string): boolean {
  return useSyncExternalStore(
    (cb) => { const m = matchMedia(query); m.addEventListener('change', cb); return () => m.removeEventListener('change', cb); },
    () => matchMedia(query).matches,
    () => false,
  );
}

// Rail layout from Aurora's lg breakpoint (1000 px); below it, top bar + bottom tabs.
export const DESKTOP_QUERY = '(min-width: 1000px)';
export const useIsDesktop = () => useMediaQuery(DESKTOP_QUERY);
